<template>
  <a-modal title="Combine brands" width="680px" :visible="visible" @cancel="visible = false" :footer="null">
    <h3>Which brand should branding options stored in ?</h3>
    <div class="inputBlock">
      <span class="inputBox">
        <a-input v-model="name" placeholder="Please enter the new brand name" />
      </span>
      <span><a-button type="primary" @click="add()">Add</a-button></span>
    </div>
    <div class="opWrap">
      <div class="opFlex" v-for="(item, i) in data" :key="i" @click="brand_group_id = item.id">
        <i :class="{ on: brand_group_id === item.id }"></i>
        {{ item.name }}
      </div>
    </div>
    <div class="modalFoot" style="text-align: right">
      <a-button @click="visible = false" style="margin-right: 20px;">Cancel</a-button>
      <a-button class="btn" type="primary" :disabled="!data.length" @click="save">Confirm</a-button>
    </div>
  </a-modal>
</template>

<script>
import { getBrandGroup, addBrandGroup } from '@/api/brand'

export default {
  name: 'Brand',
  data() {
    return {
      visible: false,
      data: [],
      brand_group_id: '',
      name: '',
      form: this.$form.createForm(this, { name: 'myBrand' })
    }
  },
  watch: {
    visible(value) {
      if (value) {
        this.brand_group_id = ''
        this.name = ''
        this.getBrandGroupFn(1)
      }
    }
  },
  components: {},
  mounted() {},
  computed: {},
  methods: {
    getBrandGroupFn(n) {
      getBrandGroup({ is_all: 1 }).then(res => {
        this.data = res.data
        if (n === 1) {
          this.brand_group_id = this.data.length ? this.data[0].id : ''
        }
      })
    },
    add() {
      addBrandGroup({ name: this.name }).then(res => {
        this.getBrandGroupFn()
      })
    },
    save() {
      this.visible = false
      this.$emit('change', { brand_group_id: this.brand_group_id })
    }
  },
  created() {}
}
</script>

<style lang="less" scoped>
.inputBlock {
  margin: 20px 0;
  display: flex;
  .inputBox {
    flex: 1;
  }
}
.opWrap {
  overflow-y: auto;
  max-height: 200px;
  &::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 5px; /*高宽分别对应横竖滚动条的尺寸*/
    height: 1px;
  }
  &::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 10px;
    // -webkit-box-shadow: inset 0 0 5px rgba(6, 6, 13, 0.2);
    background: rgba(6, 6, 13, 0.2);
  }
  &::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    border-radius: 10px;
    background: white;
  }
  .opFlex {
    margin-top: 10px;
    display: flex;
    align-items: center;
    font-size: 16px;
    color: #666;
    cursor: pointer;
    i {
      width: 16px;
      height: 16px;
      border-radius: 50%;
      margin-right: 6px;
      border: 1px solid #d9d9d9;
      &.on {
        border: 4px solid #ffa200;
      }
    }
  }
}
</style>
